import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MathJaxContext } from "better-react-mathjax";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";

// Pages
import TMUAPrep from "./pages/TMUAPrep";
import PracticeHub from "./pages/PracticeHub";
import ExamPage from "./pages/ExamPage";
import ExamPageClassic from "./pages/ExamPageClassic";
import ExamModeSelect from "./pages/ExamModeSelect";
import Dashboard from "./pages/Dashboard";
import ExamResults from "./pages/ExamResults";
import QuestionConfig from "./pages/Questionconfig";
import Login from "./pages/Login";
import AdminPage from "./pages/AdminPage";

const mathJaxConfig = {
  loader: { load: ["input/tex", "output/chtml"] },
  tex: { inlineMath: [["$", "$"], ["\\(", "\\)"]] },
};

function AppContent() {
  const { theme } = useTheme();

  return (
    <MathJaxContext config={mathJaxConfig} version={3}>
      <AuthProvider>
        <Toaster theme={theme} position="bottom-left" />
        <Router>
          <Routes>
            <Route path="/" element={<TMUAPrep />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/practice" element={<PracticeHub />} />
            <Route path="/exam-select" element={<ExamModeSelect />} />
            <Route path="/exam" element={<ExamPage />} />
            <Route path="/exam-classic" element={<ExamPageClassic />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/exam-results" element={<ExamResults />} />
            <Route path="/question-config" element={<QuestionConfig />} />
          </Routes>
        </Router>
      </AuthProvider>
    </MathJaxContext>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
